import React, { useState, useEffect, useMemo } from 'react';
import { Input, FormCustom, Select, SwitchToggle } from '../../Components/Form/Form';
import Controllers from '../../Api/Controllers';
import ReactPlaceholder from 'react-placeholder/lib';
import Button from 'react-bootstrap/Button';

const SupplierForm = ({ data, onSubmit, disablebSubmit, loadSubmit }) => {
    const [row, setRow] = useState({
        p_id: data.id || '',
        p_supplier_name: data.supplier_name || '',
        p_rfc: data.rfc || '',
        p_address: data.address || '',
        p_id_bank: data.id_bank || '',
        p_cc: data.cc || '',
        p_cci: data.cci || '',
        p_cuenta_contable: data.cuenta_contable || '',
        p_nombre_contacto: data.nombre_contacto || '',
        p_telefono_contacto: data.telefono_contacto || '',
        p_correo_contacto: data.correo_contacto || '',
        p_status: data.status
    });

    const [ready, setReady] = useState(false);
    const [banks, setBanks] = useState([]);

    useEffect(() => {
        Controllers.bank.get_bank().then(res => {
            setBanks(res.data);
            setReady(true);
        }).catch(err => console.error(err));
    }, []);

    const idBank = useMemo(() => {
        if (!row.p_id_bank) {
            return
        }

        let finded = banks.find(t => parseInt(row.p_id_bank) === parseInt(t.id_bank))

        if (!finded) {
            return
        }
        return {
            label: finded.name_bank,
            value: finded.id_bank
        }
    }, [row.p_id_bank, banks])

    return (
        <ReactPlaceholder ready={ready} showLoadingAnimation rows={15}>
            <FormCustom dataSubmit={row} onSubmit={({ data }) => onSubmit({ data })} disablebSubmit={disablebSubmit} loadSubmit={loadSubmit}>
                <Input
                    text="Nombre del Proveedor"
                    placeholder="Nombre del Proveedor"
                    classNameParent="col-12 mb-2"
                    icon="far fa-building"
                    required
                    invalid="El campo es obligatorio."
                    defaultValue={row.p_supplier_name}
                    onChange={e => setRow({ ...row, p_supplier_name: e.currentTarget.value })}
                    maxLength={255}
                />
                <Input
                    text="RFC"
                    placeholder="RFC"
                    classNameParent="col-12 mb-2"
                    icon="fa fa-id-card"
                    required
                    invalid="El campo es obligatorio."
                    defaultValue={row.p_rfc}
                    onChange={e => setRow({ ...row, p_rfc: e.currentTarget.value })}
                    maxLength={13}
                />
                <Input
                    text="Dirección"
                    placeholder="Dirección"
                    classNameParent="col-12 mb-2"
                    icon="fa fa-map-marker-alt"
                    defaultValue={row.p_address}
                    onChange={e => setRow({ ...row, p_address: e.currentTarget.value })}
                    maxLength={255}
                />
                <Select
                    classNameParent="col-12 mb-2"
                    icon="fas fa-user-tie"
                    text="Banco"
                    options={banks.map(t => {
                        return {
                            label: t.name_bank,
                            value: t.id_bank
                        }
                    })}
                    value={idBank}
                    onChange={e => setRow({ ...row, p_id_bank: e.value })}
                />
                <Input
                    text="Cuenta Corriente (CC)"
                    placeholder="Cuenta Corriente"
                    classNameParent="col-12 mb-2"
                    icon="fa fa-credit-card"
                    defaultValue={row.p_cc}
                    onChange={e => setRow({ ...row, p_cc: e.currentTarget.value })}
                    maxLength={20}
                />
                <Input
                    text="Código Interbancario (CCI)"
                    placeholder="Código Interbancario"
                    classNameParent="col-12 mb-2"
                    icon="fa fa-exchange-alt"
                    defaultValue={row.p_cci}
                    onChange={e => setRow({ ...row, p_cci: e.currentTarget.value })}
                    maxLength={20}
                />
                <Input
                    text="Cuenta Contable"
                    placeholder="Cuenta Contable"
                    classNameParent="col-12 mb-2"
                    icon="fa fa-university"
                    defaultValue={row.p_cuenta_contable}
                    onChange={e => setRow({ ...row, p_cuenta_contable: e.currentTarget.value })}
                    maxLength={100}
                />
                <Input
                    text="Nombre de Contacto"
                    placeholder="Nombre de Contacto"
                    classNameParent="col-12 mb-2"
                    icon="fa fa-user"
                    defaultValue={row.p_nombre_contacto}
                    onChange={e => setRow({ ...row, p_nombre_contacto: e.currentTarget.value })}
                    maxLength={100}
                />
                <Input
                    text="Teléfono de Contacto"
                    placeholder="Teléfono de Contacto"
                    classNameParent="col-12 mb-2"
                    icon="fa fa-phone"
                    defaultValue={row.p_telefono_contacto}
                    onChange={e => setRow({ ...row, p_telefono_contacto: e.currentTarget.value })}
                    maxLength={30}
                />
                <Input
                    type="email"
                    text="Correo de Contacto"
                    placeholder="Correo de Contacto"
                    classNameParent="col-12 mb-2"
                    icon="fa fa-envelope"
                    defaultValue={row.p_correo_contacto}
                    onChange={e => setRow({ ...row, p_correo_contacto: e.currentTarget.value })}
                    maxLength={100}
                />
                <SwitchToggle
                    classNameParent="col-12 mb-2"
                    id="supplier-enabled"
                    defaultChecked={parseInt(row.p_status) === 1}
                    onChange={e => setRow({ ...row, p_status: e.currentTarget.checked ? 1 : 0 })}
                />
            </FormCustom>
        </ReactPlaceholder>
    );
}

SupplierForm.defaultProps = {
    data: {
        id_supplier: '',
        supplier_name: '',
        rfc: '',
        address: '',
        id_bank: '',
        cc: '',
        cci: '',
        status: 1
    },
    onSubmit: () => { },
    loadSubmit: false
};

export default SupplierForm;
